import { render, staticRenderFns } from "./permissionsDialog.vue?vue&type=template&id=77b17eb3"
import script from "./permissionsDialog.vue?vue&type=script&lang=js"
export * from "./permissionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports